import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Spinner } from "reactstrap";
import { apiAdmin } from "../../services/api";
import { _imagesURL } from "../../constants/API";
import { CHAT, NEW_PROFILE_DOCTOR } from "../../constants/RoutesUrl";
import { Language } from "../../App";
import {
  IoCheckmarkOutline,
  IoClose,
  IoPersonOutline,
  IoTimeOutline,
  IoChatbubbleEllipsesOutline,
  IoChatboxEllipsesOutline,
} from "react-icons/io5";
import { FaCheck, FaArrowRight, FaChevronRight, FaPen } from "react-icons/fa";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { FiAward, FiMapPin, FiShield, FiUser } from "react-icons/fi";
import { BsBullseye, BsHeart, BsBook, BsGraphUpArrow } from "react-icons/bs";
import pinchArrow from "../../assets/images/pincharrow.svg";
import starmentor from "../../assets/images/starmentor.svg";
import health from "../../assets/images/health.svg";
import location from "../../assets/images/location.svg";
import person from "../../assets/images/person.svg";
import solar from "../../assets/images/solar.svg";
import chart from "../../assets/images/chart.svg";
import { CiLocationOn } from "react-icons/ci";
import { GoPencil } from "react-icons/go";

function StatItem({ icon, label, value }) {
  return (
    <div
      className="d-flex flex-column align-items-center text-center"
      style={{ flex: "1 1 0%", minWidth: 0 }}
    >
      <span
        className="d-flex align-items-center justify-content-center flex-shrink-0 mb-2"
        style={{
          width: "28px",
          height: "28px",
          borderRadius: "50%",
          background: "#EAF8FB",
          color: "#00A9C7",
          border: "1px solid #C9EEF4",
        }}
      >
        {icon}
      </span>
      <span
        className="fs-11 d-block"
        style={{ color: "#5F6673", fontWeight: "500" }}
      >
        {label}
      </span>
      <span
        className="fs-13 d-block text-truncate"
        style={{ color: "#0E1421", fontWeight: 400, width: "100%" }}
      >
        {value}
      </span>
    </div>
  );
}

/* Label renders INSIDE the bordered box.
   `divider` controls whether a line separates the header row from the content below.
   Pass divider={false} for sections like "About" that should flow straight from
   the header into the full-width text below, with no separating line. */
function BoxedSection({ icon, label, children, divider = true }) {
  return (
    <div
      className="mb-4"
      style={{
        border: "1px solid #D7E0EA",
        borderRadius: "14px",
        overflow: "hidden",
      }}
    >
      <div
        className="d-flex align-items-center gap-2"
        style={{
          padding: "12px 14px",
          paddingBottom: divider ? "12px" : "6px",
        }}
      >
        <span
          className="d-flex align-items-center justify-content-center"
          style={{
            width: "24px",
            height: "24px",
            borderRadius: "50%",
            background: "#EAF8FB",
            color: "#00A9C7",
            flexShrink: 0,
          }}
        >
          {icon}
        </span>
        <span className="fs-11" style={{ color: "#5F6673", fontWeight: "500" }}>
          {label}
        </span>
      </div>
      <div
        style={{
          padding: "14px",
          marginLeft: "35px",
          marginTop: "-20px",
          fontWeight: "400",
          fontSize: "12px",
          color: "#0E1421",
        }}
      >
        {children}
      </div>
    </div>
  );
}

function BenefitItem({ icon, title, sub }) {
  return (
    <div
      className="d-flex align-items-center gap-2"
      style={{ flex: "1 1 0%", minWidth: 0 }}
    >
      <span
        className="d-flex align-items-center justify-content-center flex-shrink-0"
        style={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          background: "#EAF8FB",
          color: "#00A9C7",
        }}
      >
        {icon}
      </span>
      <div style={{ minWidth: 0 }}>
        <span
          className="fs-10  d-block"
          style={{ color: "#5F6673", fontWeight: "500" }}
        >
          {title}
        </span>
        <span
          className="fs-12 d-block"
          style={{ color: "#0E1421", fontWeight: "400" }}
        >
          {sub}
        </span>
      </div>
    </div>
  );
}

// New section shown right above the "Apply" button — a compact mentor
// preview (avatar + name) with a "See complete profile" link on the right.
// Clicking it hands off to whatever the parent wants to do with a full
// profile view (open a dedicated profile page/modal, scroll up, etc.) via
// the optional onViewProfile callback; it's a no-op if nothing is passed.
function MentorProfileLinkCard({ image, name, onViewProfile }) {
  const { lang } = useContext(Language);
  return (
    <div
      onClick={onViewProfile}
      className="d-flex align-items-center justify-content-between mb-4"
      style={{
        border: "1px solid #D7E0EA",
        borderRadius: "16px",
        padding: "10px 14px",
        cursor: onViewProfile ? "pointer" : "default",
        background: "#fff",
      }}
    >
      <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
        <img
          src={image}
          alt={name}
          style={{
            width: "38px",
            height: "38px",
            borderRadius: "50%",
            objectFit: "cover",
            flexShrink: 0,
          }}
        />
        <div style={{ minWidth: 0 }}>
          <span
            className="fs-12 robot-medium d-block text-truncate"
            style={{ color: "#0E1421" }}
          >
            {name}
          </span>
          <span
            className="fs-12 robot-medium d-block"
            style={{ color: "#00BADA" }}
          >
            {lang?.mentorship_see_complete_profile || "See complete profile"}
          </span>
        </div>
      </div>
      <span
        className="d-flex align-items-center justify-content-center flex-shrink-0"
        style={{
          width: "26px",
          height: "26px",

          borderRadius: "50%",
          background: "#E8FBFF",
          color: "#00BADA",
        }}
      >
        <FaChevronRight style={{ marginLeft: "1.5px" }} size={11} />
      </span>
    </div>
  );
}

// The API's `location` is a full street address ("443, Block G4 Block G 4
// Phase 2 Johar Town, Lahore, Pakistan") — way too long for the stat
// column, so just keep the last two comma-separated parts (city, country).
function shortenLocation(location) {
  if (!location) return "";
  const parts = location
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean);
  return parts.slice(-2).join(", ");
}

// "5 minutes"/"5 minutos", "2 hours"/"2 horas" etc. — the number+unit chunk
// only, no "ago"/"in" wrapper, since word order for those differs by
// language (Spanish "hace" goes before the value, not after like English
// "ago" does) — callers wrap this with their own translated template instead
// of the unit strings baking in a fixed position.
function formatDurationParts(minutes, lang) {
  if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? lang?.min || "min" : lang?.mins || "mins"}`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} ${hours === 1 ? lang?.hour || "hour" : lang?.hours || "hours"}`;
  }
  const days = Math.floor(hours / 24);
  return `${days} ${days === 1 ? lang?.day || "day" : lang?.days || "days"}`;
}

// request.start_timestamp is the confirmed session's actual scheduled
// moment (unix seconds, timezone-agnostic — it's an absolute instant, so no
// timezone math is needed to diff it against "now"). request.time is a
// different, unrelated field (more like a created/status timestamp), which
// was producing nonsense countdowns like "1 min" for sessions actually
// booked a day or more out. Falls back to start_date+start_time only if
// start_timestamp is somehow missing.
function formatTimeUntil(request, lang) {
  let targetMs = null;
  if (request?.start_timestamp) {
    targetMs = Number(request.start_timestamp) * 1000;
  } else if (request?.start_date && request?.start_time) {
    const parsed = new Date(`${request.start_date}T${request.start_time}`);
    if (!isNaN(parsed)) targetMs = parsed.getTime();
  }
  if (!targetMs) return null;
  const diffMs = Math.abs(targetMs - Date.now());
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return lang?.mentorship_a_few_moments || "a few moments";
  return formatDurationParts(minutes, lang);
}

// request.time is NOT the moment the session went live — it stays fixed at
// whenever the request was first created (confirmed against real data: it
// matched created_at, not updated_at, and sat before start_timestamp), which
// produced a bogus, way-too-large elapsed time. start_timestamp (the actual
// scheduled/started moment) is the correct source.
function formatElapsedSince(request, lang) {
  let targetMs = null;
  if (request?.start_timestamp) {
    targetMs = Number(request.start_timestamp) * 1000;
  } else if (request?.start_date && request?.start_time) {
    const parsed = new Date(`${request.start_date}T${request.start_time}`);
    if (!isNaN(parsed)) targetMs = parsed.getTime();
  }
  if (!targetMs) return null;
  const diffMs = Math.max(Date.now() - targetMs, 0);
  const minutes = Math.floor(diffMs / 60000);
  if (minutes < 1) return lang?.just_now || "Just now";
  const timeStr = formatDurationParts(minutes, lang);
  const template = lang?.mentorship_time_ago_template || "{{time}} ago";
  return template.replace("{{time}}", timeStr);
}

// user_id here is the same mentor id that comes back in each row of
// /user/mentor/home's mentors.data — this fetches that same user's full
// mentor_profile (specialty, experience, institute, bio, focus, ...).
async function fetchMentorProfile(userId) {
  const res = await apiAdmin.post("user/mentor/profile", { user_id: userId });
  return res.data;
}

// Must match the .am-curtain-content "amCurtainOpen" animation's own
// duration below — the profile request is only fired once the curtain has
// actually finished sliding down and settled in the center, not while it's
// still mid-animation.
const OPEN_ANIMATION_MS = 800;

function ApplyMentorShip({
  isOpen,
  toggle,
  mentor,
  onApply,
  onViewProfile,
  isBooked,
  onChat,
  mode = "view",
  onManage,
}) {
  const navigate = useNavigate();
  const { lang } = useContext(Language);
  const [profileData, setProfileData] = useState(null);
  const [requestData, setRequestData] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(false);
  // False for the entire slide-down animation (the request hasn't even been
  // fired yet) — kept separate from loadingProfile so that window can render
  // a plain blank area instead of the old mentor/list-card fallback data,
  // which used to flash briefly while the curtain was still moving.
  const [fetchStarted, setFetchStarted] = useState(false);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (!isOpen || !mentor?.id) {
      setProfileData(null);
      setRequestData(null);
      setLoadingProfile(false);
      setFetchStarted(false);
      return;
    }
    let cancelled = false;
    setProfileData(null);
    setRequestData(null);
    setLoadingProfile(false);
    setFetchStarted(false);

    // Wait for the curtain to finish sliding down and settle in the center
    // before hitting the API at all — so the sequence is always: modal
    // slides down (blank) -> reaches center -> request fires -> loader
    // shows -> data replaces it, instead of the request (and its loader,
    // or stale fallback text) starting while the modal is still mid-animation.
    const openTimer = setTimeout(() => {
      if (cancelled) return;
      setFetchStarted(true);
      setLoadingProfile(true);
      fetchMentorProfile(mentor.id)
        .then((data) => {
          // data.data.mentor is the profile; data.data.request sits alongside
          // it — null means no request exists yet with this mentor, anything
          // else means one already does (so it's a chat, not an apply).
          if (!cancelled && data?.status) {
            setProfileData(data.data?.mentor || null);
            setRequestData(data.data?.request ?? null);
          }
        })
        .catch(() => {})
        .finally(() => {
          if (!cancelled) setLoadingProfile(false);
        });
    }, OPEN_ANIMATION_MS);

    return () => {
      cancelled = true;
      clearTimeout(openTimer);
    };
  }, [isOpen, mentor?.id]);

  // Same curtain-modal pattern as NewCourseDetail2.0.jsx's VideoModal —
  // a plain backdrop + content div pair driven by CSS @keyframes, not
  // reactstrap's Modal/Fade. isClosing keeps both mounted for the close
  // animation's own 800ms before actually telling the parent to close
  // (toggle) and firing whatever action triggered the close — so the
  // curtain always finishes sliding back up before anything else happens,
  // exactly mirroring how it slides down on open.
  const closeThen = (callback) => {
    setIsClosing(true);
    setTimeout(() => {
      toggle();
      setIsClosing(false);
      callback?.();
    }, 800);
  };
  const handleClose = () => closeThen();

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") handleClose();
    };
    if (isOpen) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  if (!mentor) return null;
  if (!isOpen && !isClosing) return null;

  const isOwnProfile = mode === "own";
  // The API's request is authoritative once it's loaded; the isBooked prop
  // (local booking-flow state) still covers the moment right after booking,
  // before this modal has re-fetched.
  const hasRequest = isBooked || !!requestData;

  // Until the real profile loads (or for own-profile mode, which has no
  // user_id to fetch), fall back to whatever the mentor list card already
  // had — so the modal never has to sit there blank.
  const mentorProfile = profileData?.mentor_profile || {};
  const display = profileData
    ? {
        image: profileData.image
          ? `${_imagesURL}${profileData.image}`
          : mentor.image,
        name: profileData.name || mentor.name,
        specialty:
          mentorProfile.specialty ||
          profileData.category ||
          profileData.subcategory ||
          mentor.specialty,
        bio: mentorProfile.bio || profileData.bio || mentor.bio,
        institution: mentorProfile.institute || mentor.institution,
        // The API has no second-line institution subtitle field — leave it
        // unset rather than always falling back to the mock own-profile
        // object's hardcoded "Ophthalmology Reference Center".
        institutionSub: undefined,
        // The API returns a full street address — too long for this stat
        // column, so just the last two comma-separated parts (city, country).
        location: shortenLocation(profileData.location) || mentor.location,
        experience: mentorProfile.experience || mentor.experience,
        // Same "&&&&" join used everywhere else this field shows up.
        focusAreas: mentorProfile.focus
          ? mentorProfile.focus.split("&&&&").filter(Boolean)
          : mentor.focusAreas || [],
      }
    : mentor;

  const {
    image,
    name,
    specialty,
    bio,
    institution,
    institutionSub,
    location,
    experience,
    focusAreas = [],
  } = display;

  const handleApply = () => closeThen(() => onApply?.(mentor));

  const handleViewFullProfile = () =>
    closeThen(() => {
      onViewProfile?.(mentor);
      navigate(`${NEW_PROFILE_DOCTOR}/${mentor.id}`);
    });

  // Same navigate(CHAT, { state: {...} }) shape ChatHeader.jsx / Chats.jsx
  // read via useLocation() — see MentorShipSchedule.jsx's message button for
  // the reference usage. `to`/`user.user_id` use mentor.id (the mentor's real
  // user id, same one fetchMentorProfile above was called with), and
  // `user.name` uses `display.name` rather than the raw `mentor` prop so it
  // reflects the freshly-fetched profile once that's loaded. `user.image` is
  // left "" — ChatHeader/Chats prepend _imagesURL to whatever's there, and
  // `display.image` may already be a full URL or a bundled placeholder
  // import, either of which would break if prefixed again; both components
  // already fall back to the placeholder avatar when it's "".
  const handleChat = () => {
    const loginId = JSON.parse(localStorage.getItem("SplashData") || "null")
      ?.user?.id;
    closeThen(() => {
      onChat?.(mentor);
      navigate(CHAT, {
        state: {
          from: loginId,
          to: mentor.id,
          group_id: 0,
          user: {
            user_id: mentor.id,
            name: display.name,
            image: "",
          },
        },
      });
    });
  };

  const handleManage = () => closeThen(() => onManage?.(mentor));

  return (
    <div
      className={`am-curtain-backdrop ${isClosing ? "closing" : ""}`}
      onClick={handleClose}
    >
      <style>{`
        /* Curtain modal — same pattern as NewCourseDetail2.0.jsx's
           VideoModal: a plain backdrop + content div pair animated with
           @keyframes, not reactstrap's Modal/Fade. Because both open and
           close are driven by our own isClosing state (see closeThen)
           instead of a UI-library class toggle gated behind a JS timeout,
           the content starts moving the instant it's told to, in both
           directions — so closing is a true mirror of opening. */
        .am-curtain-backdrop {
          position: fixed;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          animation: amBackdropFadeIn 0.8s ease-out forwards;
        }
        .am-curtain-backdrop.closing {
          animation: amBackdropFadeOut 0.8s ease-out forwards;
        }
        .am-curtain-content {
          position: relative;
          width: 100%;
          max-width: 633px;
          max-height: 90vh;
          overflow-y: auto;
          background: #fff;
          border: 0.5px solid #E6E7EA;
          border-radius: 26px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.05);
          transform: translateY(-100vh);
          animation: amCurtainOpen 0.8s ease-out forwards;
        }
        .am-curtain-content.closing {
          animation: amCurtainClose 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        }
        @keyframes amBackdropFadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        @keyframes amBackdropFadeOut {
          0% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes amCurtainOpen {
          0% { transform: translateY(-100vh); }
          100% { transform: translateY(0); }
        }
        @keyframes amCurtainClose {
          0% { transform: translateY(0); }
          100% { transform: translateY(-100vh); }
        }
        @media (prefers-reduced-motion: reduce) {
          .am-curtain-backdrop, .am-curtain-content {
            animation: none !important;
          }
        }
        .am-modal-body {
          padding: 28px;
        }
        @media (max-width: 768px) {
          .am-modal-body {
            padding: 22px;
          }
        }
        @media (max-width: 576px) {
          .am-curtain-content {
            border-radius: 18px;
          }
          .am-modal-body {
            padding: 16px;
          }
          .am-header-photo {
            width: 140px !important;
            height: 140px !important;
            margin: 0 auto;
          }
        }
      `}</style>
      <div
        className={`am-curtain-content ${isClosing ? "closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="position-relative am-modal-body"
          style={{
            background:
              "linear-gradient(180deg, #DAFAFF 0px, #EFFDFF 30px, #FFFFFF 120px, #FFFFFF 100%)",
          }}
        >
          {/* Close */}
          <button
            type="button"
            onClick={handleClose}
            className="position-absolute d-flex align-items-center justify-content-center border-0"
            style={{
              top: "16px",
              right: "16px",
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              background: "#fff",
              boxShadow: "0 2px 8px rgba(15,26,43,0.16)",
            }}
          >
            <IoClose size={18} color="#0E1421" />
          </button>

          {!fetchStarted ? (
            // Curtain is still sliding down — nothing fetched yet, so just a
            // blank area (no spinner, no mentor/list-card fallback text) sits
            // here until it settles in the center and the request fires.
            <div style={{ minHeight: "420px" }} />
          ) : loadingProfile ? (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{ minHeight: "420px" }}
            >
              <Spinner
                style={{ color: "#1dc1dd", width: "2.5rem", height: "2.5rem" }}
              />
            </div>
          ) : (
            <>
              {/* Header — photo stretches full height of the right column (name + institution + stats);
            stacks and centers on small screens where the 180px photo + text side-by-side no longer fits */}
              <div className="d-flex flex-column flex-sm-row align-items-center align-items-sm-stretch gap-3 mb-4">
                <div
                  className="am-header-photo"
                  style={{
                    width: "180px",
                    height: "220px",
                    borderRadius: "16px",

                    overflow: "hidden",
                    flexShrink: 0,
                    border: "2px solid #fff",
                    background: "#e5e7eb",
                  }}
                >
                  <img
                    src={image}
                    alt={name}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      display: "block",
                    }}
                  />
                </div>

                {/* Right column: badge/name/institution on top, stats pinned to bottom (aligns with photo bottom) */}
                <div
                  className="flex-fill d-flex flex-column justify-content-between align-items-center align-items-sm-stretch"
                  style={{ minWidth: 0, width: "100%" }}
                >
                  <div className="text-center text-sm-start">
                    <span
                      className="d-inline-block mb-2 roboto-medium"
                      style={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#0E1421",
                        background: "#1DC1DD33",
                        borderRadius: "6px",
                        padding: "4px 14px",
                      }}
                    >
                      {specialty}
                    </span>
                    <h4
                      className=" mb-2"
                      style={{
                        fontSize: "20px",
                        fontWeight: "700",
                        color: "#0F1A2B",
                      }}
                    >
                      {name}
                    </h4>
                    {institution && (
                      <div className="d-flex align-items-center justify-content-center justify-content-sm-start gap-2 mb-1">
                        <HiOutlineBuildingOffice2 size={18} color="#4B5563" />
                        <span
                          className="fs-12 "
                          style={{
                            color: "#0E1421",
                            fontWeight: "500",
                            letterSpacing: "0.4px",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: "600",
                              fontSize: "12px",
                              textTransform: "uppercase",
                            }}
                          >
                            {lang?.institution || "Institution"}
                          </span>
                          <br />
                          {institution}
                          {institutionSub && (
                            <p
                              className="fs-12  mb-0"
                              style={{ color: "#5F6673", fontWeight: "400" }}
                            >
                              {institutionSub}
                            </p>
                          )}
                        </span>
                      </div>
                    )}
                  </div>

                  {/* Divider spans only the right column, then stats sit flush beneath it */}
                  <div className="w-100">
                    <div
                      className="mt-3 mb-3"
                      style={{ borderTop: "1px solid #EAEEF2" }}
                    />
                    <div
                      className="d-flex justify-content-between"
                      style={{ gap: "12px", fontWeight: "400" }}
                    >
                      <StatItem
                        icon={
                          <img
                            src={starmentor}
                            alt="Specialist"
                            width={16}
                            height={16}
                          />
                        }
                        label={
                          lang?.mentorship_specialist_label || "Specialist"
                        }
                        value={specialty}
                      />

                      <StatItem
                        icon={<CiLocationOn size={20} />}
                        label={lang?.location || "Location"}
                        value={location}
                      />

                      <StatItem
                        icon={
                          <img
                            src={health}
                            alt="Experience"
                            width={16}
                            height={16}
                          />
                        }
                        label={lang?.experience || "Experience"}
                        value={experience}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {/* About — person icon like the reference image, no divider under the header,
            description text flows full-width right below the "About" label */}
             <BoxedSection
  icon={<img src={person} alt="About" width={18} height={18} />}
  label={lang?.mentorship_about_label || "About"}
  divider={false}
>
  <p
    className="fs-13 roboto-regular mb-0"
    style={{
      color: "#5F6673",
      lineHeight: "20px",
      whiteSpace: "normal",
      wordBreak: "break-word",
      overflowWrap: "break-word",
    }}
  >
    {bio}
  </p>
</BoxedSection>

              {/* Focus Area — label + icon inside the box, with divider */}
              {focusAreas.length > 0 && (
                <BoxedSection
                  icon={
                    <img
                      src={pinchArrow}
                      alt="Focus Area"
                      style={{
                        width: "14px",
                        height: "14px",
                        objectFit: "contain",
                      }}
                    />
                  }
                  label={lang?.mentorship_focus_area_label || "Focus Area"}
                >
                  <div className="row gy-2">
                    {focusAreas.map((item) => (
                      <div
                        className="col-12 col-sm-6 d-flex align-items-start gap-2"
                        key={item}
                      >
                        <IoCheckmarkOutline
                          size={15}
                          color="#1DC1DD"
                          style={{
                            marginTop: "2px",
                            flexShrink: 0,
                            backgroundColor: "#DFF8FB",
                            borderRadius: "50%",
                            padding: "2",
                          }}
                        />
                        <span
                          className="fs-12 text-truncate"
                          style={{
                            color: "#0F1A2B",
                            fontWeight: "400",
                            minWidth: 0,
                          }}
                          title={item}
                        >
                          {item}
                        </span>
                      </div>
                    ))}
                  </div>
                </BoxedSection>
              )}

              {/* Divider before benefits row */}
              <div
                className="mb-3"
                style={{ borderTop: "1px solid #EAEEF2" }}
              />

              {/* Benefits — stacks on small screens where 3 columns squeeze the labels into multi-line wraps */}
              <div
                className="d-flex flex-column flex-sm-row justify-content-between mb-4 pt-1"
                style={{ gap: "12px" }}
              >
                <BenefitItem
                  icon={<img src={solar} alt="Heart" width={14} height={14} />}
                  title={
                    lang?.mentorship_benefit_guidance_title ||
                    "Personal Guidance"
                  }
                  sub={
                    lang?.mentorship_benefit_guidance_sub || "1:1 Mentorship"
                  }
                />

                <BenefitItem
                  icon={
                    <img src={starmentor} alt="Book" width={14} height={14} />
                  }
                  title={
                    lang?.mentorship_benefit_experience_title ||
                    "Learn from experience"
                  }
                  sub={
                    lang?.mentorship_benefit_experience_sub || "Expert Support"
                  }
                />

                <BenefitItem
                  icon={<img src={chart} alt="Growth" width={14} height={14} />}
                  title={
                    lang?.mentorship_benefit_goals_title || "Achieve your goals"
                  }
                  sub={lang?.mentorship_benefit_goals_sub || "Career Growth"}
                />
              </div>

              {/* Mentor preview card — quick link back to the full profile,
            sits between the benefits row and the Apply button. Not shown
            for your own profile — you're already looking at it. */}
              {!isOwnProfile && (
                <MentorProfileLinkCard
                  image={image}
                  name={name}
                  onViewProfile={handleViewFullProfile}
                />
              )}

              {/* request.status: 0 = mentor hasn't confirmed yet (still just a
            pending request), 1 = confirmed (session scheduled but not yet
            started), 2 = session actually live right now — each gets its
            own banner instead of lumping 0/2 into the same generic one. */}
              {hasRequest &&
                !isOwnProfile &&
                (requestData?.status === 2 ? (
                  <div
                    className="d-flex align-items-start gap-2 mb-3"
                    style={{
                      background: "#FFEFAD",
                      borderRadius: "12px",
                      padding: "12px 14px",
                      border: "1px solid #FFEA94",
                    }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#FFFFFF85",
                        color: "#FFCC00",
                      }}
                    >
                      <IoTimeOutline size={16} />
                    </span>
                    <p
                      className="fs-13 mb-0"
                      style={{
                        color: "#0E1421",
                        fontWeight: "400",
                        lineHeight: "18px",
                      }}
                    >
                      {(() => {
                        const template =
                          lang?.mentorship_session_in_progress_desc ||
                          "Your mentorship session with this mentor is in progress";
                        const [prefix, suffix] = template.split("{{time}}");
                        const timeValue =
                          formatElapsedSince(requestData, lang) ||
                          lang?.mentorship_recently_fallback ||
                          "recently";
                        return (
                          <>
                            {prefix}
                            <strong style={{ fontWeight: 700 }}>
                              {timeValue}
                            </strong>
                            {suffix}
                          </>
                        );
                      })()}
                    </p>
                  </div>
                ) : requestData?.status === 1 ? (
                  <div
                    className="d-flex align-items-start gap-2 mb-3"
                    style={{
                      background: "#FFEFAD",
                      borderRadius: "12px",
                      padding: "12px 14px",
                      border: "1px solid #FFEA94",
                    }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#FFFFFF85",
                        color: "#FFCC00",
                      }}
                    >
                      <IoTimeOutline size={16} />
                    </span>
                    <p
                      className="fs-13 mb-0"
                      style={{
                        color: "#0E1421",
                        fontWeight: "400",
                        lineHeight: "18px",
                      }}
                    >
                      {(() => {
                        const template =
                          lang?.mentorship_session_scheduled_desc ||
                          "Your consultation with this mentor is scheduled in {{time}} — we'll notify you before it starts.";
                        const [prefix, suffix] = template.split("{{time}}");
                        const timeValue =
                          formatTimeUntil(requestData, lang) ||
                          lang?.mentorship_soon_fallback ||
                          "soon";
                        return (
                          <>
                            {prefix}
                            <strong style={{ fontWeight: 700 }}>
                              {timeValue}
                            </strong>
                            {suffix}
                          </>
                        );
                      })()}
                    </p>
                  </div>
                ) : (
                  <div
                    className="d-flex align-items-start gap-2 mb-3"
                    style={{
                      background: "#FFEFAD",
                      borderRadius: "12px",
                      padding: "12px 14px",
                      border: "1px solid #FFEA94",
                    }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "26px",
                        height: "26px",
                        borderRadius: "50%",
                        background: "#FFFFFF85",
                        color: "#FFCC00",
                      }}
                    >
                      <IoTimeOutline size={16} />
                    </span>
                    <p
                      className="fs-13 mb-0"
                      style={{
                        color: "#0E1421",
                        fontWeight: "400",
                        lineHeight: "18px",
                      }}
                    >
                      {lang?.mentorship_request_sent_desc ||
                        "Your request has been sent to this mentor. Please wait — we'll notify you once they confirm your session."}
                    </p>
                  </div>
                ))}

              {isOwnProfile ? (
                <button
                  type="button"
                  onClick={handleManage}
                  className="w-100 d-flex align-items-center justify-content-center gap-2 border-0 text-white"
                  style={{
                    background: "#1DC1DD",
                    borderRadius: "999px",
                    fontWeight: "700",
                    padding: "12px",
                    fontSize: "14px",
                  }}
                >
                  <GoPencil size={16} />{" "}
                  {lang?.mentorship_manage_profile_button ||
                    "Manage Mentor Profile"}
                </button>
              ) : hasRequest ? (
                <button
                  type="button"
                  onClick={handleChat}
                  className="w-100 d-flex gap-2 align-items-center justify-content-center  border-0 text-white"
                  style={{
                    background: "#1DC1DD",
                    borderRadius: "999px",
                    fontWeight: "700",
                    padding: "12px",
                    fontSize: "16px",
                  }}
                >
                  <IoChatboxEllipsesOutline size={20} />{" "}
                  {lang?.mentorship_chat_with_mentor_button ||
                    "Chat with Mentor"}
                </button>
              ) : (
                <button
                  type="button"
                  onClick={handleApply}
                  className="w-100 d-flex align-items-center justify-content-center gap-2 border-0 text-white"
                  style={{
                    background: "#1DC1DD",
                    borderRadius: "999px",
                    fontWeight: "700",
                    padding: "12px",
                    fontSize: "14px",
                  }}
                >
                  {lang?.mentorship_apply_for_mentorship_button ||
                    "Apply for Mentorship"}{" "}
                  <FaArrowRight size={13} />
                </button>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default React.memo(ApplyMentorShip);
